import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../../../utils/rel';

class AutoBtn extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    render() {
        const { content } = this.props;

        return (
            <div className={styles.auto_btn}>
                <div className={styles.btn0}>
                    <a href={content[0].url} target="_blank" rel={rel}>
                        {content[0].title}
                    </a>
                </div>
                <div className={styles.btn1}>
                    <a href={content[1].url} target="_blank" rel={rel}>
                        {content[1].title}
                    </a>
                </div>
            </div>
        );
    }
}

export default errorBoundary(AutoBtn);
